import { render, staticRenderFns } from "./CmgLeaderboardBadgePanel.vue?vue&type=template&id=27c2c674&scoped=true&lang=pug"
import script from "./cmg-leaderboard-badge-panel.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-badge-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardBadgePanel.vue?vue&type=style&index=0&id=27c2c674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2c674",
  null
  
)

export default component.exports